var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('keep-alive',{attrs:{"include":_vm.$store.state.settings.include}},[_c('router-view',{key:_vm.$route.path,staticClass:"app-content"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }